$(document).ready(function () {

  $('.collection-product__image').each(function(i, el) {

    var hoverAnimation = gsap.timeline({ paused: true })
      .add('start')
      .fromTo($(this).find('.particle--one'),
        { opacity: 0 },
        { opacity: 1, display: 'block', duration: 0.05 },
        'start'
      )
      .fromTo($(this).find('.particle--two'),
        { opacity: 0 },
        { opacity: 1, display: 'block', duration: 0.05 },
        'start'
      )
      .fromTo($(this).find('.particle--three'),
        { opacity: 0 },
        { opacity: 1, display: 'block', duration: 0.05 },
        'start'
      );

    var hoveringCan = gsap.timeline({ paused: true, repeat: -1 })
      .fromTo($(this).find('.collection-product-image__content img'),
        { y: 0 },
        { y: 5, duration: 2.5, immediateRender: false }
      )
      .fromTo($(this).find('.collection-product-image__content img'),
        { y: 5 },
        { y: 0, duration: 2.5, immediateRender: false }
      );

    var hoveringOne = gsap.timeline({ paused: true, repeat: -1 })
      .fromTo($(this).find('.particle--one'),
        { y: 0 },
        { y: 5, duration: 2.2, immediateRender: false }
      )
      .fromTo($(this).find('.particle--one'),
        { y: 5 },
        { y: 0, duration: 2.2, immediateRender: false }
      );

    var hoveringTwo = gsap.timeline({ paused: true, repeat: -1 })
      .fromTo($(this).find('.particle--two'),
        { y: 0 },
        { y: 5, duration: 1.8, immediateRender: false }
      )
      .fromTo($(this).find('.particle--two'),
        { y: 5 },
        { y: 0, duration: 1.8, immediateRender: false }
      );

    var hoveringThree = gsap.timeline({ paused: true, repeat: -1 })
      .fromTo($(this).find('.particle--three'),
        { y: 0 },
        { y: 5, duration: 2, immediateRender: false }
      )
      .fromTo($(this).find('.particle--three'),
        { y: 5 },
        { y: 0, duration: 2, immediateRender: false }
      );

    el.hoverAnimation = hoverAnimation;
    el.hoveringCan = hoveringCan;
    el.hoveringOne = hoveringOne;
    el.hoveringTwo = hoveringTwo;
    el.hoveringThree = hoveringThree;
  });

  // Animation for elements with .loop--4 class
// for_mango();
//   function for_mango(){
//     $('.loop--4').each(function() {
//           this.hoverAnimation.play();
//           this.hoveringCan.play();
//           this.hoveringOne.play();
//           this.hoveringTwo.play();
//           this.hoveringThree.play();
//     });
//   }

// setInterval(function () {
//   for_mango();
// },1000)

  if ($(window).width() > 1024) {

  //   $('.collection-product__image')
  //     .mouseenter(function () {
  //       $(this).addClass('is_hovering');

  //       this.hoverAnimation.play();
  //       this.hoveringCan.play();
  //       this.hoveringOne.play();
  //       this.hoveringTwo.play();
  //       this.hoveringThree.play();

  //     })
  //     .mouseleave(function () {
  //       $(this).removeClass('is_hovering');
  //      // $('.loop--4').addClass('is_hovering');// for mango only .loop--4 class
  //      // for_mango();// for mango only .loop--4 class
  //       this.hoverAnimation.reverse();
  //       this.hoveringCan.pause();
  //       this.hoveringOne.pause();
  //       this.hoveringTwo.pause();
  //       this.hoveringThree.pause();
  //     });

  // } else {

    $('.collection-product__image').each(function () {
      this.hoverAnimation.play();
      this.hoveringCan.play();
      this.hoveringOne.play();
      this.hoveringTwo.play();
      this.hoveringThree.play();
    });

  }

});
